import angular from 'angular';

let toast = angular
    .module("toast", ["toastHtmlTemplate"]);

export default toast;